import { render, staticRenderFns } from "./InfoPasajero.vue?vue&type=template&id=cdfde14e&scoped=true&"
import script from "./InfoPasajero.vue?vue&type=script&lang=js&"
export * from "./InfoPasajero.vue?vue&type=script&lang=js&"
import style0 from "./InfoPasajero.vue?vue&type=style&index=0&id=cdfde14e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfde14e",
  null
  
)

export default component.exports